import React from 'react';
import { getTranslatedString } from 'helpers/i18n';
import { serviceRequestVerbiage } from 'helpers/VerbiageHelper';
import SuccessFace from 'components/ui/AnimatedStates/SuccessFace';

const AcknowledgeTicketSuccess = ({ onClick }) => (
  <SuccessFace
    onClick={onClick}
    headerText={getTranslatedString('maintenanceVendors.acknowledgeSuccess.title', {
      requestVerbiage: serviceRequestVerbiage('capitalized'),
    })}
    bodyText={getTranslatedString('maintenanceVendors.acknowledgeSuccess.body')}
    buttonText={getTranslatedString('maintenanceVendors.acknowledgeSuccess.button')}
  />
);

export default AcknowledgeTicketSuccess;
